import * as React from 'react';
import { FC, useRef } from 'react';

import { Box, ScrollView } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { Helmet } from 'components/helmet';
import { LayoutContainer } from 'components/layout/styled';
import { CustomScrollViewProps } from 'components/onboarding-multi-step/types';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import { LoyaltyQuickPayWidget } from '../loyalty-widgets/loyalty-quick-pay-widget';

import { ShortCodeOfferStatusPoller } from './components/short-code-offer-status-poller';
import { ShortCodePaymentResultPoller } from './components/short-code-payment-result-poller';
import {
  CodeHeaderText,
  TermsContainer,
  TermsText,
} from './loyalty-in-restaurant-redemption.styled';
import { LoyaltyInRestaurantRedemptionViewProps } from './types';
import { useLoyaltyMyCode } from './use-loyalty-my-code';

const LoyaltyInRestaurantRedemptionView: FC<React.PropsWithChildren<
  LoyaltyInRestaurantRedemptionViewProps
>> = ({ widgets }) => {
  const isMobile = useIsMobileBreakpoint();
  const { formatMessage } = useIntl();
  const { data, loading } = useLoyaltyMyCode();

  const scrollViewRef = useRef<CustomScrollViewProps | null>(null);

  if (loading) {
    return null;
  }

  return (
    <>
      <LayoutContainer isFullContainer={isMobile}>
        <ScrollView ref={scrollViewRef}>
          <Helmet title={formatMessage({ id: 'redeemInRestaurant' })} />
          <Box minHeight="100vh">
            <CodeHeaderText content={data?.myCodeTitle?.locale} />
            {widgets.topWidgets.map(({ element }) => element)}
            <LoyaltyQuickPayWidget></LoyaltyQuickPayWidget>
            {widgets.bottomWidgets.map(({ element }) => element)}
            {!loading && data?.myCodeLegalTerms?.locale && (
              <TermsContainer>
                <TermsText content={data?.myCodeLegalTerms?.locale} />
              </TermsContainer>
            )}
          </Box>
        </ScrollView>
      </LayoutContainer>

      <ShortCodeOfferStatusPoller />
      <ShortCodePaymentResultPoller />
    </>
  );
};

export default LoyaltyInRestaurantRedemptionView;
